import React, { useContext } from 'react';
import { ViewAssessment as MphViewAssessment } from "@premkumarmph/assessment-library";
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../../context/globalContext';
import './ViewAssessment.scss';

export const ViewAssessment = () => {
  const navigate = useNavigate();
  const { carousel } = useContext(GlobalContext);

  const handleClose = () => {
    navigate('/'); // will change once prev screen is ready
  };
  return (
    <div id="viewAssessmentRootId" className="viewAssessmentRoot">
      <MphViewAssessment handleClose={handleClose} logoURL={carousel.logo} />
    </div>
  );
};
